/** Strip HTML tags and collapse whitespace for previews / required checks. */
export function stripHtml(html) {
  return String(html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function isRichTextEmpty(html) {
  return !stripHtml(html);
}

export function looksLikeHtml(value) {
  return /<[a-z][\s\S]*>/i.test(String(value || ""));
}
